import ContrastOutlinedIcon from '@mui/icons-material/ContrastOutlined';

/**
 * Localização do melasma: áreas do rosto com mancha, mais de uma ao mesmo tempo.
 * Referência clínica: padrões clínicos centrofacial, malar e mandibular de
 * Sanchez NP et al. (J Am Acad Dermatol 1981;4:698-710). Testa, nariz, lábio
 * superior e queixo compõem o padrão centrofacial. Textos nossos.
 *
 * Os valores precisam ser os mesmos de public/api/scales/catalog/melasma_location.php.
 */
const melasmaLocation = {
  key: 'melasma_location',
  name: 'Localização do melasma',
  description: 'Áreas do rosto com mancha: padrão centrofacial, malar ou mandibular',
  details: 'Registra em quais áreas do rosto o melasma aparece. As áreas formam os três padrões clínicos clássicos: testa, nariz, lábio superior e queixo correspondem ao padrão centrofacial, o mais comum; as maçãs do rosto, ao malar; e a linha da mandíbula, ao mandibular. Ajuda a planejar o tratamento e a ver se a mancha recua ou se espalha. Marque todas as áreas com mancha; o card mostra as da última consulta e a aba Saúde guarda a evolução.',
  kind: 'multiple',
  icon: ContrastOutlinedIcon,
  accent: 'amber',
  options: [
    { value: 'forehead', label: 'Testa', caption: 'Centrofacial', image: 'melasma-1.png', help: 'Mancha na testa, em faixa ou em placas, geralmente no centro.' },
    { value: 'temples', label: 'Têmporas', image: 'melasma-2.png', help: 'Mancha nas laterais da testa, perto da linha do cabelo.' },
    { value: 'nose', label: 'Nariz', caption: 'Centrofacial', image: 'melasma-3.png', help: 'Mancha no dorso do nariz, às vezes ligando as duas maçãs do rosto.' },
    { value: 'malar', label: 'Malar (maçãs do rosto)', caption: 'Malar', image: 'melasma-4.png', help: 'Mancha sobre as maçãs do rosto, geralmente dos dois lados.' },
    { value: 'upper_lip', label: 'Lábio superior', caption: 'Centrofacial', image: 'melasma-5.png', help: 'Mancha acima da boca, na região do buço. Costuma piorar com calor e depilação.' },
    { value: 'chin', label: 'Queixo', caption: 'Centrofacial', image: 'melasma-6.png', help: 'Mancha no queixo, isolada ou junto com a do lábio superior.' },
    { value: 'mandibular', label: 'Mandíbula', caption: 'Mandibular', image: 'melasma-7.png', help: 'Mancha ao longo da linha da mandíbula, na parte de baixo do rosto.' },
  ],
};

export default melasmaLocation;
